// panel/src/components/CallButton/index.js
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import { useVoice } from "context/VoiceContext";

function CallButton({ phoneNumber }) {
  const voice = useVoice();
  if (!voice || voice.status === "unavailable" || !phoneNumber) return null;

  const disabled = voice.status !== "idle";
  const title = !disabled
    ? `Call ${phoneNumber}`
    : voice.status === "error"
    ? "Calling isn't working right now — reload the page to try again"
    : "Already on a call";

  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          size="small"
          color="info"
          disabled={disabled}
          sx={{ width: { xs: 40, md: "auto" }, height: { xs: 40, md: "auto" } }}
          onClick={(e) => {
            e.stopPropagation();
            voice.startCall(phoneNumber);
          }}
        >
          <Icon fontSize="small">call</Icon>
        </IconButton>
      </span>
    </Tooltip>
  );
}

CallButton.propTypes = {
  phoneNumber: PropTypes.string,
};
CallButton.defaultProps = {
  phoneNumber: "",
};

export default CallButton;
